import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IAuthState } from './types';
import { ERPUserDTOType } from '../../schemas/identity';

const INITIAL_STATE: IAuthState = {
  token: null,
  refreshToken: null,
  erpUser: null,
} as const;

const identitySlice = createSlice({
  name: 'identity',
  initialState: INITIAL_STATE,
  reducers: {
    setTokens: (state, action: PayloadAction<{ token: string; refreshToken: string }>) => {
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
    },
    setErpUser: (state, action: PayloadAction<ERPUserDTOType>) => {
      state.erpUser = action.payload;
    },
    clearAuth: () => INITIAL_STATE,
  },
});

export const { setTokens, setErpUser, clearAuth } = identitySlice.actions;

export const identityReducer = identitySlice.reducer;
